import useAuth from "@/hooks/useAuth";
import React, { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

const LogoutPage = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    logout();
    navigate("/auth/login");
  }, []);

  return null;
};

export default LogoutPage;
